import * as React from 'react';
import { useNavigate } from 'react-router';
import type { PiletApi } from '@chess/platform-web';
import { registerCard } from '@chess/api-dashboard';
import { registerAggregator, useAggregate } from '@chess/api-model/react';
import '@chess/api-insights/charts.css';
import './accuracy-trend.css';
import { AccuracyTrendCard } from './AccuracyTrendCard.tsx';
import { AccuracyTrendAggregator } from './AccuracyTrendAggregator.ts';

// Home dashboard card "Accuracy": registers its own aggregator with the game
// store, reads its result and renders `AccuracyTrendCard`, its body, in the
// Summary section's frame (`registerCard` on `home.section.summary`, order 20: after Rating trend, before Games
// and results): a dot per scanned game of the last 30 days, the worst three
// numbered on the chart. A dot opens that game's review.
export function setup(app: PiletApi) {
  const getApi = <T,>(name: string) => app.getApi<T>(name);
  const aggregator = new AccuracyTrendAggregator();
  registerAggregator(getApi, aggregator);
  const Card: React.FC = () => {
    const { result, state } = useAggregate(getApi, aggregator);
    const navigate = useNavigate();
    // Never hidden while the store loads: the card shows skeletons for its values.
    if (state?.status !== 'ready') return state?.status === 'failed' ? null : <AccuracyTrendCard loading />;
    const p = state.period;
    return result && p ? <AccuracyTrendCard {...result} from={p.from} to={p.to} onOpen={(path) => navigate(path)} /> : null;
  };
  registerCard(app, 'home.section.summary', Card, { order: 20, title: 'Accuracy' });
}
